import auto1 from '../images/auto_1.jpg';
import auto2 from '../images/auto_2.jpg';
import auto3 from '../images/auto_3.jpg';
import auto4 from '../images/auto_4.jpg';
import auto5 from '../images/auto_5.jpg';
import auto6 from '../images/auto_6.jpg';
import auto7 from '../images/auto_7.jpg';

const automotive_data = {
  busGroup : {
    client: "Custom Bus Group / Custom Coaches", 
    title: "Miscellaneous", 
    image_array: [
      {
        image: auto1, 
        category: "automotive", 
        title: 'Miscellaneous', 
        comment: "Miscellaneous project by the custom bus group"
      },
      {
        image: auto2, 
        category: "automotive", 
        title: 'Miscellaneous', 
        comment: "Miscellaneous project by the custom bus group"
      },
      {
        image: auto3, 
        category: "automotive", 
        title: 'Miscellaneous', 
        comment: "Miscellaneous project by the custom bus group"
      },
      {
        image: auto4, 
        category: "automotive", 
        title: 'Miscellaneous', 
        comment: "Miscellaneous project by the custom bus group"
      },
      {
        image: auto5, 
        category: "automotive", 
        title: 'Miscellaneous', 
        comment: "Miscellaneous project by the custom bus group"
      },
      {
        image: auto6, 
        category: "automotive", 
        title: 'Miscellaneous', 
        comment: "Miscellaneous project by the custom bus group"
      },
      {
        image: auto7, 
        category: "automotive", 
        title: 'Miscellaneous', 
        comment: "Miscellaneous project by the custom bus group"
      },
    ]
  }
};

export default automotive_data;